module.exports = __webpack_public_path__ + "img/hide.816e5620.svg";